import Vue from 'vue'
import Vuex from 'vuex'
import json from '@/main.json'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    item: '',
    message: null,
    all_items: '',
    item_correct: '',
    part_head_correct: null,
    part_torso_correct: null,
    part_hand_correct: null,
    part_feet_correct: null,
    mobile_current_target: ''
  },
  getters: {
    item : state => {
      return state.item
    },
    message : state => {
      return state.message
    },
    all_items : state => {
      return state.all_items
    },
    item_correct: state => {
      return state.item_correct
    },
    part_head_correct: state => {
      return state.part_head_correct
    },
    part_torso_correct: state => {
      return state.part_torso_correct
    },
    part_hand_correct: state => {
      return state.part_hand_correct
    },
    part_feet_correct: state => {
      return state.part_feet_correct
    },
    mobile_current_target: state => {
      return state.mobile_current_target
    },
  },
  mutations: {
    set_item : (state, payload) => {
      state.item = payload;
    },
    set_message : (state, payload) => {
      state.message = payload;
    },
    set_all_items : (state, payload) => {
      state.all_items = payload;
    },
    set_item_correct : (state, payload) => {
      state.item_correct = payload;
    },
    set_part_head_correct : (state, payload) => {
      state.part_head_correct = payload;
    },
    set_part_torso_correct : (state, payload) => {
      state.part_torso_correct = payload;
    },
    set_part_hand_correct : (state, payload) => {
      state.part_hand_correct = payload;
    },
    set_part_feet_correct : (state, payload) => {
      state.part_feet_correct = payload;
    },
    set_mobile_current_target : (state, payload) => {
      state.mobile_current_target = payload;
    },
  },
  actions : {}
})